
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 4h10c1.645 0 3 1.355 3 3v18c0 1.645-1.355 3-3 3H11c-1.645 0-3-1.355-3-3V7c0-1.645 1.355-3 3-3zm0 2c-.555 0-1 .445-1 1v18c0 .555.445 1 1 1h10c.555 0 1-.445 1-1V7c0-.555-.445-1-1-1H11zm5 17a1 1 0 110 2 1 1 0 010-2z"}})])
          )
        }
      }
    